export default {"src":"/_next/static/media/codesignal-atlas.871ea5dd.svg","height":64,"width":64};